<template>
  <DAccordion value="0" class="w-full">
    <DAccordionPanel value="0">
      <DAccordionHeader>Render Settings</DAccordionHeader>
      <DAccordionContent>
        <SettingPanelControls nodeType="render" dataType="viewport_settings" />
      </DAccordionContent>
    </DAccordionPanel>

    <DAccordionPanel value="1">
      <DAccordionHeader>Grid</DAccordionHeader>
      <DAccordionContent>
        <SettingPanelControls nodeType="grid" dataType="viewport_settings" />
      </DAccordionContent>
    </DAccordionPanel>

    <DAccordionPanel value="2">
      <DAccordionHeader>Brightness</DAccordionHeader>
      <DAccordionContent>
        <SettingPanelControls nodeType="brightness" dataType="viewport_settings" />
      </DAccordionContent>
    </DAccordionPanel>
  </DAccordion>
</template>

<script setup>
import SettingPanelControls from './SettingPanelControls.vue';

import { DAccordion, DAccordionContent, DAccordionHeader, DAccordionPanel } from '@disguise/cloud-ui';
</script>
